import React, { useState } from 'react'
import { ArrowLeft, ZoomIn } from "lucide-react";
import { host } from '../../api/ApiCalls';
import { toast } from "react-toastify";
import { tostifyOption } from '../../utils/toastOptions';
import axios from 'axios';


const TeacherApprovals = ({component, setComponent, unapprovedTeachers, setUnapprovedTeachers}) => {
    const [zoomImage, setZoomImage] = useState(null);
    const [approvingId, setApprovingId] = useState(null);
const [rejectingId, setRejectingId] = useState(null);

  console.log(unapprovedTeachers)
    const handleApprove = async (id)=>{
      setApprovingId(id);
        await axios.put(`${host}/api/admin/approve-teacher/${id}`);
        toast.success("Teacher approved", tostifyOption);
        setApprovingId(null);
    };
    const handleReject = async (id)=>{
        if (window.confirm("Are you sure you want to reject this teacher?")) {
            setRejectingId(id);
            await axios.put(`${host}/api/admin/reject-teacher/${id}`);
            toast.error("Teacher rejected", tostifyOption);
            setRejectingId(null);
        }
    };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h2 className="text-3xl font-bold mb-6">
        <button className='p-2 hover:bg-gray-100 rounded' onClick={() => setComponent("AdminDashboard")}>
                  {/* luicide-react go back icon */}
                  <ArrowLeft className="h-6 w-6 text-gray-500 mr-2" />
                </button>
        Teacher Approvals
        </h2>
      {unapprovedTeachers.length === 0 ? (
        <p>No pending teacher approvals</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {unapprovedTeachers.map((teacher) => (
            <div
              key={teacher._id}
              className="bg-white shadow rounded p-4 flex flex-col items-center text-center"
            >
              <img
                src={teacher.avatar}
                alt={teacher.name}
                className="w-20 h-20 rounded-full object-cover mb-2"
                onClick={() => setZoomImage(teacher.avatar)}
              />
              <h3 className="text-lg font-semibold">{teacher.name}</h3>
              <p className="text-sm text-gray-600 mb-2">{teacher.email}</p>

              <div className="mb-3">
                <img
                  src={teacher.degreeImage}
                  alt="Degree"
                  className="h-32 object-cover rounded cursor-pointer border"
                  onClick={() => setZoomImage(teacher.degreeImage)}
                />
                <p className="text-xs text-gray-400 mt-1">Click to zoom</p>
              </div>

              <div className="flex gap-2">
                <button
                  onClick={() => handleApprove(teacher._id)}
                  className="bg-indigo-500 text-white px-3 py-1 rounded hover:bg-indigo-600 disabled:opacity-50"
                  disabled={approvingId === teacher._id}
                >
                  {approvingId === teacher._id ? (
    <div className="flex items-center justify-center gap-1">
      <svg
        className="animate-spin h-4 w-4 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
        />
      </svg>
      Approving...
    </div>
  ) : (
    "Approve"
  )}
                </button>
                <button
                  onClick={() => handleReject(teacher._id)}
                  className="bg-indigo-500 text-white px-3 py-1 rounded hover:bg-indigo-600 disabled:opacity-50"
                  disabled={rejectingId === teacher._id}
                >
                  {rejectingId === teacher._id ? (
    <div className="flex items-center justify-center gap-1">
      <svg
        className="animate-spin h-4 w-4 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
        />
      </svg>
      Rejecting...
    </div>
  ) : (
    "Reject"
  )}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Zoom Modal */}
      {zoomImage && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-80 flex justify-center items-center">
          <div className="relative">
            <img
              src={zoomImage}
              alt="Zoomed Degree"
              className="max-h-[90vh] max-w-[90vw] object-contain border rounded"
            />
            <button
              onClick={() => setZoomImage(null)}
              className="absolute top-2 right-2 text-white text-xl bg-gray-700 hover:bg-gray-800 rounded-full p-1"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default TeacherApprovals